import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from './ar.json';
import en from './en.json';

const STORAGE_KEY = 'sds_lang';
const saved = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
const initialLang = saved || 'ar';

i18n.use(initReactI18next).init({
  resources: {
    ar: { translation: ar },
    en: { translation: en },
  },
  lng: initialLang,
  fallbackLng: 'ar',
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

// Apply dir/lang to <html>
function applyHtmlDir(lng) {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
}
applyHtmlDir(initialLang);

i18n.on('languageChanged', (lng) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, lng);
  } catch (e) {
    // localStorage may be disabled (private mode, quota). Log and continue —
    // language still applies for the current session.
    console.warn('[i18n] cannot persist language', e);
  }
  applyHtmlDir(lng);
});

export default i18n;
